import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { api, errMsg } from "@/api";
import { formatAccessCode } from "@/lib/utils";
import StatusBadge from "@/components/StatusBadge";

const fmt = (iso) =>
  new Date(iso).toLocaleString("id-ID", { timeZone: "Asia/Jakarta", day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" });
const fmtDate = (iso) =>
  new Date(iso).toLocaleDateString("id-ID", { timeZone: "Asia/Jakarta", day: "2-digit", month: "short", year: "numeric" });

export default function MyBookings() {
  const [bookings, setBookings] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/bookings").then(({ data }) => setBookings(data))
      .catch((e) => toast.error(errMsg(e))).finally(() => setLoading(false));
  }, []);

  return (
    <div className="space-y-6 pb-24">
      <div>
        <h1 className="font-heading text-[26px] font-semibold tracking-tight text-slate-900">Booking Saya</h1>
        <p className="mt-1.5 text-sm text-slate-500">Pantau status pengajuan dan kode akses storage Anda.</p>
      </div>

      {loading ? <p className="text-sm text-slate-500">Memuat…</p> : (
        <div data-testid="my-bookings-list" className="space-y-4">
          {bookings.map((b) => (
            <Link key={b.id} to={`/peminjaman/${b.id}`} data-testid={`booking-row-${b.code}`}
              className="block rounded-lg border border-slate-200 bg-white p-5 sm:p-6 transition-colors duration-200 hover:border-slate-400">
              <div className="flex flex-wrap items-start justify-between gap-4">
                <div className="space-y-2">
                  <p className="font-mono text-xs text-slate-500">{b.code} / {b.booking_type === "LOCATION_ONLY" ? "Tanpa barang" : `${b.total_qty} pcs`}</p>
                  <h3 className="font-heading text-xl font-semibold tracking-tight text-slate-900">{b.purpose}</h3>
                  <p className="text-sm text-slate-600">Mulai {fmt(b.start_time)} / selesai {fmt(b.end_time)}</p>
                  <p className="text-sm text-slate-600">{b.location_name_snapshot || b.custom_location || "Lokasi legacy"}</p>
                  <p className="text-sm text-slate-500">
                    {b.lines.slice(0, 3).map((l) => `${l.name} (${l.qty})`).join(", ")}
                    {b.lines.length > 3 ? ` +${b.lines.length - 3} lain` : ""}
                  </p>
                </div>
                <div className="flex flex-col items-end gap-3">
                  <StatusBadge status={b.status} tone="light" />
                  {b.booking_type !== "LOCATION_ONLY" && b.access && b.status !== "PENDING" && (
                    <p className="font-mono text-sm font-semibold text-emerald-700">Kode: {formatAccessCode(b.access.code)}</p>
                  )}
                </div>
              </div>
            </Link>
          ))}
          {bookings.length === 0 && <p className="text-sm text-slate-500">Belum ada booking.</p>}
        </div>
      )}
    </div>
  );
}
